// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oH2n","input":"styles_input__25y6l"};